<template lang="pug">
  v-container#victims(fluid)
    h1.form-title.purple-text Víctima(s)
    v-layout.py-3(row wrap)
      v-container(xs-12 fluid)
        v-layout(column)
          v-form
            v-layout(
              row
              wrap
              align-center
              v-for="(victim, index) in victims"
              :key="index"
            )
              v-flex.px-3.pt-4(xs1)
                v-checkbox(
                  :value="victim.selected"
                  v-model="victim.selected"
                  v-if="!(index === victims.length - 1)"
                )
              v-flex.px-3(xs2)
                v-text-field(
                  label="Nombre"
                  :value="victim.name"
                  v-model="victim.name"
                  required
                )
              v-flex.px-3(xs2)
                v-text-field(
                  label="Medio / Colectivo"
                  :value="victim.media"
                  v-model="victim.media"
                  required
                )
              v-flex.px-3(xs2)
                v-text-field(
                  label="Cargo"
                  :value="victim.position"
                  v-model="victim.position"
                  required
                )
              v-flex.px-3(xs3)
                v-select(
                  :items="aggressionType"
                  label="Agresión"
                  v-model="victim.aggression_type"
                )
              v-flex.px-3(xs2)
                //  v-text-field(
                    label="Perpetrador"
                    :value="victim.perpetrator"
                    v-model="victim.perpetrator"
                  )
                v-select(
                  :items="perpetrator"
                  label="Perpetrador"
                  v-model="victim.perpetrator"
                )
            v-layout(row wrap justify-end)
              v-btn.victim-btn(flat @click="addVictim") Agregar víctima
              v-btn.victim-btn(flat, @click="deleteVictims", v-if="victims.length > 1") Borrar selección
</template>
<script>
export default {
  name: "Victims",
  props: {},
  data() {
    return {
      selected: false,
      victims: this.$store.state.record.victims,
      perpetrator: [
        "Funcionario público",
        "Partido político",
        "Crimen organizado",
        "Particular",
        "Se desconoce"
      ]
    };
  },
  computed: {
    aggressionType() {
      return this.$store.state.record.aggression_type;
    }
  },
  methods: {
    addVictim() {
      const victims = Array.from(this.victims);
      this.$store.commit("updateVictims", victims);
      this.victims.push({});
    },
    deleteVictims() {
      const result = this.victims.filter(victim => victim.selected !== true);
      this.victims = result;
    }
  },
  mounted() {
    this.victims.push({});
  }
};
</script>
<style scoped lang="scss">
@import "../app.scss";
#victims {
  .victim-btn {
    color: $purple;
    font-weight: 600;
    text-transform: none;
  }
}
</style>
